import { Subject, Observable } from 'rxjs';
import { ModalRef } from 'src/app/services';



export interface IPopup {
  /**
   * Closes the popup.
   */
  close(result?: any): void;

  /**
   * Observable the completes when the popup is closed. Will contain the optional result of the popup.
   */
  afterClosed(): Observable<any>;
}

export class PopupRef implements IPopup {
  result?: any;

  closeObservable = new Subject();
  constructor(private modalRef: ModalRef) {
    modalRef.addEventListener('xnAfterHide', (e: CustomEvent) => {
      if (e.target instanceof HTMLElement && (e.target as HTMLElement).tagName === 'xena-modal') {
        this.handleAfterHide();
      }
    })
  }

  close(result?: any): void {
    this.result = result;
    this.modalRef.setAttribute('open', 'false');

    // This ensures that we can somewhat test functionality in a testbed without XenaDS
    if(!(this.modalRef as any).open) this.handleAfterHide();
  }

  afterClosed() {
    return this.closeObservable;
  }

  private dispose() {
    if(this.modalRef.parentElement != null) {
      this.modalRef.parentElement.removeChild(this.modalRef);
    }
  }

  private handleAfterHide() {
    this.dispose();
    this.closeObservable.next(this.result);
  }

}
